<p-sidebar [(visible)]="appMain.rightMenuActive" [position]="app.isRTL ? 'left' : 'right'" [blockScroll]="true" [showCloseIcon]="false" [baseZIndex]="1000" [styleClass]="'layout-rightmenu p-sidebar-sm fs-small p-py-3 ' + (app.isRTL ? 'p-pl-0 p-pr-3' : 'p-pl-3 p-pr-0')">
    <div class="online-members p-d-flex p-flex-column p-mt-3" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}">
        <h6 class="header">ONLINE MEMBERS</h6>
        <div class="p-d-flex p-flex-row p-flex-wrap">
            <img class="p-m-1" src="assets/demo/images/avatar/avatar-1.png" alt="avatar-1"/>
            
        </div>
        <span class="p-mt-3"><b>+19</b> Costumers</span>
    </div>
</p-sidebar>
